const STORAGE_KEY = 'suarte:pollVotes';

const isBrowser = typeof window !== 'undefined';

const safeReadStore = () => {
  if (!isBrowser) return {};
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

const safeWriteStore = (store) => {
  if (!isBrowser) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    /* ignore quota errors */
  }
};

export const persistPollVote = (postId, pollId, optionIndex) => {
  if (!postId || !pollId || optionIndex === undefined || optionIndex === null) {
    return;
  }
  const store = safeReadStore();
  const postKey = String(postId);
  const pollKey = String(pollId);
  const postEntry = store[postKey] || {};

  postEntry[pollKey] = {
    optionIndex,
    savedAt: Date.now(),
  };

  store[postKey] = postEntry;
  safeWriteStore(store);
};

export const getPersistedPollVote = (postId, pollId) => {
  if (!postId || !pollId) return null;
  const store = safeReadStore();
  const postEntry = store[String(postId)];
  if (!postEntry) return null;
  return postEntry[String(pollId)] || null;
};

export const hydratePollsWithPersistedVotes = (postId, polls = []) =>
  polls.map(poll => {
    if (poll?.hasVoted || poll?.userAnswer !== undefined && poll?.userAnswer !== null) {
      return poll;
    }

    const persisted = getPersistedPollVote(postId, poll?.pollId);
    if (!persisted) return poll;

    return {
      ...poll,
      hasVoted: true,
      userAnswer: persisted.optionIndex,
    };
  });
